<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div
		id="data-list-list-view"
		class="data-list-container"
	>
		<vs-alert
			title="Hiba!"
			active="true"
			color="danger"
			v-if="errorMessage"
		>
			{{ errorMessage }}
		</vs-alert>
		<vx-card>
			<div class="flex">
				<vs-button
					color="primary"
					size="large"
					type="flat"
					icon="icon-arrow-left"
					icon-pack="feather"
					@click="$router.go(-1)"
				></vs-button>
				<h4 class="mt-3">
					Statisztika
					<span v-if="transactions">
						({{ transactionsCount }} db)
					</span>

				</h4>
				<div class="rounded-lg cursor-pointer items-center justify-center right-button inline-buttons">
					<vx-tooltip
						text="Keresés törlése">
						<vs-button
							class="btn-drop mr-2"
							type="border"
							size="medium"
							icon-pack="feather"
							icon="icon-x"
							color="grey"
							@click.stop="resetSearch()"
						></vs-button>
					</vx-tooltip>
					<vx-tooltip
						text="Exportálás">
						<vs-button
							class="btn-drop mr-2"
							type="border"
							size="medium"
							icon-pack="feather"
							icon="icon-printer"
							color="grey"
							@click.stop="exportStatistics()"
						></vs-button>
					</vx-tooltip>
				</div>
			</div>

			<div
					
					class="flex items-center flex-grow justify-between"
				>
					<div class="flex items-center data-list-btn-container flex-wrap">
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 400px"
						>
							<label class="vs-select--label" for="">Dolgozó</label>
							<v-select
								:multiple="true"
								height="auto"
								:hide-selected="true"
								:small-chips="true"
								class="w-full worker-select"
								v-model="search.worker"
								:options="searchData.workers"
								placeholder="Mind"
								:reduce="worker => worker.id"
								label="fullName"/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 300px"
						>
							<label class="vs-select--label" for="">Megrendelő</label>
							<v-select
								class="w-full"
								v-model="search.customer"
								:options="searchData.customers"
								placeholder="Mind"
								:reduce="customer => customer.id"
								label="displayName"/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 250px"
						>
							<label class="vs-select--label" for="">Ügyfél</label>
							<vs-input
								placeholder="Ügyfél"
								v-model="search.client"
								class="w-full"
								autocomplete="none"
							/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 200px"
						>
							<label class="vs-select--label" for="">Típus</label>
							<v-select
								class="w-full"
								v-model="search.transactionType"
								:options="searchData.transactionTypes"
								label="label" 
								placeholder="Mind"
								:reduce="transactionType => transactionType.id"/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 220px"
						>
							<label class="vs-select--label" for="">Feladat/státusz</label>
							<v-select
								class="w-full"
								v-model="search.transactionPhase"
								:options="searchData.transactionPhases"
								label="name"
								placeholder="Mind"
								:reduce="transactionPhase => transactionPhase.id"/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 100px"
						>
							<label class="vs-select--label" for="">Kezdődátum</label>
							<datepicker
								:full-month-name=true
								:monday-first=true
								:language="langHu"
								:format="customFormatter"
								name="deadline"
								v-model="search.startDate"
							></datepicker>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 100px"
						>
							<label class="vs-select--label" for="">Végdátum</label>
							<datepicker
								:full-month-name=true
								:monday-first=true
								:language="langHu"
								:format="customFormatter"
								name="deadline"
								v-model="search.endDate"
							></datepicker>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center pt-5"
							v-if="searchData"
							style="width: 100px"
						>
							<vs-button
								color="primary"
								size="medium"
								class="pull-right btn-add-new"
								type="filled"
								icon-pack="feather"
								icon="icon-search"
								@click="filterTransactions(true)"
							>
								Szűrés
							</vs-button>
						</div>
					</div>
				</div>

			<vs-table
				:hoverFlat="true"
				stripe
				:notSpacer="true"
				:data="transactions"
				noDataText="Nincs találat"
				v-if="transactions"
			>

				<template slot="thead">
					<vs-th>
						Ügyszám
					</vs-th>
					<vs-th>
						Dolgozó
					</vs-th>
					<vs-th>
						Megrendelő
					</vs-th>
					<vs-th>
						Típus
					</vs-th>
					<vs-th>
						Feladat kód
					</vs-th>
					<vs-th>
						Státusz
					</vs-th>
					<vs-th>
						Ingatlan
					</vs-th>
					<vs-th>
						Díj
					</vs-th>
					<vs-th>
						Dátum
					</vs-th>
					<vs-th>
						
					</vs-th>
				</template>

				<template v-for="(transaction, indextr) in transactions" >
					<vs-tr
						v-bind:key="indextr"
					>
						<vs-td :data="transactions[indextr].transactionNumber ? transactions[indextr].transactionNumber : ''">
							<router-link
								v-if="!transactions[indextr].locked || currentUser.id == transactions[indextr].lockedBy.id"
								:to="/ugylet/ + transactions[indextr].id"
							>{{ transactions[indextr].transactionNumber }}</router-link>
							<span v-if="transactions[indextr].locked && currentUser.id != transactions[indextr].lockedBy.id">{{ transactions[indextr].transactionNumber }}</span>
						</vs-td>
						<vs-td>
							<!-- Dolgozó -->
							{{ transactions[indextr].worker ? transactions[indextr].worker.fullName : '' }}
						</vs-td>
						<vs-td>
							<!-- Megrendelő -->
							{{ transactions[indextr].customer.name }}
						</vs-td>
						<vs-td>
							<!-- Típus -->
							{{ transactions[indextr].transactionType.parent ? transactions[indextr].transactionType.parent.name : transactions[indextr].transactionType.name }}
						</vs-td>
						<vs-td>
							<!-- Feladat kód -->
							{{ transactions[indextr].taskCode }}
						</vs-td>
						<vs-td>
							<!-- Státusz -->
							{{ transactions[indextr].phase.name }}							
						</vs-td>
						<vs-td>
							<!-- Ingatlan -->
							{{ transactions[indextr].property.fullAddress }}							
						</vs-td>
						<vs-td>
							<!-- Díj -->
							{{ transactions[indextr].price }} Ft
						</vs-td>	
						<vs-td>
							<!-- Dátum -->
							{{ transactions[indextr].date }}
						</vs-td>	
						<vs-td>
							<vx-tooltip
									text="Hiányzó adat"
									v-if="transactions[indextr].isDeficient" 
								>
								<feather-icon 
									icon="AlertCircleIcon" 
									svgClasses="stroke-current text-warning" />
							</vx-tooltip>
							<feather-icon 
								v-if="!transactions[indextr].isDeficient" 
								icon="CheckIcon" 
								svgClasses="stroke-current text-success" />
						</vs-td>					
					</vs-tr>
				</template>
			</vs-table>
			<vs-pagination
				:total="numberOfPages"
				v-model="currentPage"
			></vs-pagination>
		</vx-card>
	</div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { hu } from "vuejs-datepicker/src/locale"
import moment from 'moment'
import _ from 'lodash'
import vSelect from 'vue-select'

export default {
	components: {
		Datepicker,
		'v-select': vSelect,

	},
	data() {
		return {
			search: {
				customer: null,
				transactionType: null,
				itemsPerPage: 20,
				currentPage: 1,
				worker: null,
			},
			transactions: null,
			errorMessage: this.$route.params.error,
			searchData: null,
			itemsPerPage: 20,
			queryString: '',
			numberOfPages: 0,
			currentPage: 1,
			phases: null,
			workers: null,
			langHu: hu
		}
	},
	computed: {
		
	},
	watch: {
		subTransactionTypeId() {
			let type = this.searchData.transactionTypes.find(e => e.id == this.subTransactionTypeId)
			this.subTransaction.type = type
		},
		currentPage() {
			this.search.currentPage = this.currentPage
			this.search.itemsPerPage =  this.itemsPerPage
			if(typeof this.search.customer == 'object' && this.search.customer != null && this.search.customer[0]) {
				this.search.customer = this.search.customer[0].id
			}

			if(typeof this.search.worker == 'object') {
				let workerArray = []
				for (let i = 0; i < this.search.worker.length; i++) {
					if (typeof this.search.worker[i].id != 'undefined') {
						workerArray.push(this.search.worker[i].id)
					}
				}

				if(workerArray.length > 1) {
					this.search.worker = workerArray
				}
			}

			if(typeof this.search.transactionPhase == 'object') {
				if (typeof this.search.transactionPhase[0] != 'undefined' && typeof this.search.transactionPhase[0].id != 'undefined') {
					this.search.transactionPhase  = this.search.transactionPhase[0].id
				}
			}

			if(typeof this.search.transactionType == 'object') {
				if (typeof this.search.transactionType[0] != 'undefined' && typeof this.search.transactionType[0].id != 'undefined') {
					this.search.transactionType  = this.search.transactionType[0].id
				}
			}

			let queryString = '?'
			queryString += '&' + Object.keys(this.search).map(key => key + '=' + this.search[key]).join('&');
			this.queryString = queryString

			console.log(queryString);

			history.replaceState(null, '', '/statisztika' + queryString);

			this.getTransactions(this.search);
		}
	},
	methods: {
		resetSearch() {
			this.search.worker = null
			this.search.customer = null
			this.search.client = null
			this.search.type = null
			this.search.transactionType = null
			this.search.startDate = null
			this.search.endDate = null
		},
		customFormatter(date) {
			return moment(date).format('YYYY.MM.DD.');
		},
		dateformatForBackend(date) {
			if(date && date !== '' && date !== null) {
				return moment(date).format('YYYY-MM-DD');
			} else {
				return ''
			}
		},
		// fetch(filters = null) {
		// 	this.$vs.loading()
		// 	let queryString = '?currentPage=' + this.currentPage + '&itemsPerPage=' + this.itemsPerPage
		// 	if (filters) {
		// 		this.search.startDate = this.dateformatForBackend(this.search.startDate)
		// 		this.search.endDate = this.dateformatForBackend(this.search.endDate)
		// 		queryString += '&' + Object.keys(filters).map(key => key + '=' + filters[key]).join('&');
		// 	} else {
		// 		this.search.customer = null
		// 		this.search.client = ''
		// 		this.search.transactionType = null
		// 		// this.search.transactionPhases = ''
		// 	}

		// 	this.queryString = queryString

		// 	this.$http.get('/api/statistics/list/' + queryString)
		// 		.then((response) => {
		// 			this.transactions = response.data.data
		// 			this.transactionWorker = response.data.worker
		// 			this.currentUser = JSON.parse(localStorage.getItem('userInfo'))
		// 			this.transactionsCount = response.data.sum;
		// 			this.numberOfPages = Math.ceil(response.data.sum / this.itemsPerPage);
		// 			this.$vs.loading.close()
		// 		})
		// 		.catch(() => {
		// 			this.$vs.loading.close()
		// 			this.$vs.notify({
		// 				title: 'Hiba',
		// 				text: 'Elnézést! A rendszer hibába ütközött.',
		// 				iconPack: 'feather',
		// 				icon: 'icon-alert-circle',
		// 				color: 'danger',
		// 				position: 'bottom-center'
		// 			})
		// 		})
		// },
		fetch(filters = null) {
			console.log('FETCH');
			let queryString = ''

			this.$vs.loading()

			if(typeof filters.currentPage == 'undefined') {
				filters.currentPage = 1;
			}

			if(typeof filters.itemsPerPage == 'undefined') {
				filters.itemsPerPage = 20;
			}

			if(filters && !filters.currentPage && !filters.itemsPerPage) {
				queryString += '?currentPage=' + filters.currentPage + '&itemsPerPage=' + filters.itemsPerPage
			} else {
				queryString += '?'
			}

			if (filters) {
				filters.startDate = this.dateformatForBackend(this.search.startDate)
				filters.endDate = this.dateformatForBackend(this.search.endDate)

				if(typeof filters.customer == 'object' && filters.customer !== null && filters.customer.length > 0) {
					filters.customer = filters.customer[0].id
				}

				if(typeof filters.transactionType == 'object' && filters.transactionType !== null && filters.transactionType.length > 0) {
					filters.transactionType = filters.transactionType[0].id
				}

				if(typeof filters.transactionPhase == 'object' && filters.transactionPhase !== null && filters.transactionPhase.length > 0) {
					filters.transactionPhase = filters.transactionPhase[0].id
				}

				if(typeof this.search.worker == 'object' && this.search.worker != null) {
					let workerArray = []
					for (let i = 0; i < this.search.worker.length; i++) {
						if (typeof this.search.worker[i].id != 'undefined') {
							workerArray.push(this.search.worker[i].id)
						}
					}

					if(workerArray.length > 1) {
						this.search.worker = workerArray
					}
				}

				queryString += '&' + Object.keys(filters).map(key => key + '=' + filters[key]).join('&');
				this.queryString = queryString

				history.replaceState(null, '', '/statisztika' + queryString);
				
				this.search = this.$route.query

			} else {
				this.search.customer = null
				this.search.client = ''
				this.search.property = ''
				this.search.parcelNumber = ''
				this.search.taskCode = ''
				this.search.transactionNumber = ''
				this.search.transactionType = null
				this.search.startDate = null
				this.search.endDate = null
				this.search.transactionPhase = ''
				this.search.currentPage = 1
				this.search.itemsPerPage = 20
				history.replaceState(null, '', '/statisztika');
			}
			this.$vs.loading.close()
			
			this.getTransactions(this.search)
		},
		getTransactions(search) {
			search.itemsPerPage = search.itemsPerPage ? search.itemsPerPage : this.itemsPerPage
			search.currentPage = search.currentPage ? search.currentPage : this.currentPage

			console.log(search.currentPage);

			this.currentPage = search.currentPage ? parseInt(search.currentPage) : this.currentPage
			this.itemsPerPage = search.itemsPerPage ? parseInt(search.itemsPerPage) : this.itemsPerPage

			this.$vs.loading()

			let queryString = '?'
			if(!_.isEmpty(search)) {
				queryString += '&' + Object.keys(search).map(key => key + '=' + search[key]).join('&');
			}

			this.queryString = queryString

			this.$http.get('/api/statistics/list/' + queryString)
				.then((response) => {
					this.transactions = response.data.data
					this.transactionWorker = response.data.worker
					this.currentUser = JSON.parse(localStorage.getItem('userInfo'))
					this.transactionsCount = response.data.sum;
					this.numberOfPages = Math.ceil(response.data.sum / this.itemsPerPage);
					this.$vs.loading.close()
				})
				.catch(() => {
					this.$vs.loading.close()
					this.$vs.notify({
						title: 'Hiba',
						text: 'Elnézést! A rendszer hibába ütközött.',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger',
						position: 'bottom-center'
					})
				})
		},
		fetchSearchData() {
			this.$vs.loading()
			this.$http.get('/api/statistics/search-data')
				.then((response) => {
					this.searchData = response.data
					this.search.customer = this.searchData.customers.filter(tr => tr.id == this.search.customer);
					if(this.search.worker) {
						let selectedWorkersArray = []
						for (let x = 0; x < this.searchData.workers.length; x++) {
							for (let y = 0; y < this.search.worker.length; y++) {
								const el1 = this.searchData.workers[x];
								const el2 = this.search.worker[y];

								if(el1.id == el2) {
									selectedWorkersArray.push(el1)
								}
							}
						}

						this.search.worker = selectedWorkersArray;


						// this.search.worker = this.searchData.workers.filter(tr => tr.id.includes(this.search.worker));
					}
					this.search.transactionType = this.searchData.transactionTypes.filter(tr => tr.id == this.search.transactionType);
					this.search.transactionPhase = this.searchData.transactionPhases.filter(tr => tr.id == this.search.transactionPhase);
					this.$vs.loading.close()
					this.searchData = response.data
				})
				.catch((error) => {
					this.$vs.loading.close()
					this.showError(error)
				})
		},
		exportStatistics() {
			this.$vs.loading()
			this.queryString += '&export=1'
			this.$http.get('/api/statistics/list/' + this.queryString)
				.then((response) => {
					const url = response.data.filePath
					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', response.data.fileName)
					document.body.appendChild(link)
					link.click()
					this.$vs.loading.close()
					this.printModal = false
				})
				.catch((error) => {
					// console.log(error);
					this.showError(error)
					this.$vs.loading.close()
					this.printModal = false
				})
		},
		filterTransactions: _.debounce(function (reset = false) {
			console.log(reset);
			if(reset) {
				console.log('RESET');
				this.search.currentPage = 1
			}
			this.fetch(this.search)
		}, 500),

		showError(error) {
			this.$vs.loading.close()
			this.$vs.notify({
				time: 8000,
				title: 'Hiba',
				text: 'Elnézést! A rendszer hibába ütközött. <br> --- <br>' + error,
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'danger',
				position: 'bottom-center'
			})
		}
	},
	created() {
		this.fetchSearchData()

		this.search = this.$route.query
		if(typeof this.$route.query.worker == 'string') {
			this.search.worker = this.$route.query.worker.split(',')
		}

		if(Object.keys(this.$route.query).length > 0) {
			this.fetch(this.search)
		}

		if (this.errorMessage) {
			setTimeout(() => {
				this.errorMessage = null
			}, 8000);
		}
	},
	mounted() {
		this.isMounted = true;
	}
}
</script>

<style lang="scss">
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 0rem;
			margin-right: 0rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 10px;
				}
				td.td-check {
					padding: 10px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				background-color: #fff;
				padding-top: 10px;
				padding-bottom: 10px;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}

		.vs-table--content {
			margin-top: 20px;
		}
	}
}
</style>
